import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { LoadingScreenService } from '../../services/loading-screen.service';
import { Store } from '@ngxs/store';
import { ClearClientState } from '../../state/ClientSelectionState/ClientSelection.state';

@Component({
  selector: 'lib-logout',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.css'],
  standalone: false
})
export class LoggedOutComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private loadingScreenService: LoadingScreenService,
    private store: Store,
    private ngModalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new ClearClientState());
    this.loadingScreenService.stopLoading();

    // resolve scenario where user is logged out by identity server
    // (not the front end's idle timeout) and the user attempts
    // to open a modal such as a task. once opened, 401 requests will
    // be hit when data is attempted to be fetched and the user
    // will be kicked to this component. if the modal is not dismissed,
    // the task will remain open while on this page.
    this.ngModalService.dismissAll();
  }

  public login() {
    this.authService.startAuthentication();
  }
}
